import React from "react";
export var defaultEnvConfig = {
  IGNORE_AUTH: false,
  SITE_TITLE: '',
  SITE_TITLE_TEMPLATE: '',
  SITE_OPEN_GRAPH_TITLE_TEMPLATE: '',
  SITE_DESCRIPTION: '',
  SITE_HEADLINE: '',
  SITE_IMAGE: '',
  SITE_LOGO_NAVIGATION_URL: '/',
  SITE_URL: '',
  SITE_VIDEO: '',
  SITE_TYPE: 'website',
  SITE_TWITTER: '',
  SITE_THREADS: '',
  SITE_YOUTUBE: '',
  SITE_FACEBOOK: '',
  SITE_LINKEDIN: '',
  SITE_FLICKR: '',
  SITE_TIKTOK: '',
  SITE_INSTAGRAM: '',
  SITE_NAME: '',
  SITE_RECAPTCHA_KEY: '',
  SITE_SIDEBAR_WIDTH: 56,
  SITE_SIDEBAR_MENU_WIDTH: 64,
  SITE_SIDEBAR_COLOR: '#969696',
  SITE_HEADER_HEIGHT_MOBILE: 56,
  SITE_HEADER_HEIGHT_TABLET: 64,
  SITE_HEADER_HEIGHT_DESKTOP: 72,
  ENABLE_LANG: false,
  DEFAULT_LANG: 'en',
  LANGS_COMING_SOON: '',
  MAX_WIDTH_CONTENT: '1088px',
  MAX_WIDTH_FEATURE: '',
  MAX_WIDTH_EXPLORER: '',
  PLATFORM_NAME: '',
  PLATFORM_URL: '',
  GPT_SERVER: '',
  ORG_NAME: '',
  CONTRIBUTE_BUTTON_LABEL: '',
  DATA_VIZ_PANEL_HIDE_LABEL: 'Hide Visualisation',
  PDF_DOWNLOAD_NAME: '',
  CLOUDINARY_CLOUD_NAME: '',
  CLOUDINARY_UPLOAD_PRESET: '',
  DEBUG_ICON_LINK: false,
  DEBUG_ENTITIES: false,
  DEBUG_EMBED_PROPS: false,
  DEBUG_SITE_VARS: false,
  DEBUG_PAGE_NAVIGATION: false,
  DEBUG_LINEAR_NAVIGATION: false,
  FEED_ENTRY_GRID_TITLE: 'Articles',
  PERSON_BANNER_LABEL: 'Profile:',
  SUPPORT_EMAIL: '',
  CONTACT_EMAIL: '',
  HOME_PAGE_SLUG: '',
  MAIN_MENU_SLUG: '',
  FOOTER_MENU_SLUG: '',
  FOOTER_SECONDARY_MENU_SLUG: '',
  EXPLORER_PAGE_PATH: '',
  PRIVACY_PATH: '',
  TERMS_PATH: '',
  GOOGLE_SITE_VERIFICATION_KEY: '',
  GOOGLE_ANALYTICS_TRACKING_ID: '',
  GOOGLE_SEARCH_API_KEY: '',
  ICON_LOGO_LABEL: '',
  ICON_LOGO_COLOR: '',
  LOGO_VERTICAL_OFFSET: 0,
  LOGO_HORIZONTAL_OFFSET: 0,
  LOGO_VERTICAL_OFFSET_MOBILE: 0,
  LOGO_HORIZONTAL_OFFSET_MOBILE: 0,
  LOGO_VERTICAL_OFFSET_TABLET: 0,
  LOGO_HORIZONTAL_OFFSET_TABLET: 0,
  LOGO_VERTICAL_OFFSET_DESKTOP: 0,
  LOGO_HORIZONTAL_OFFSET_DESKTOP: 0,
  LOGO_HEIGHT_MOBILE: 0,
  LOGO_HEIGHT_TABLET: 0,
  LOGO_HEIGHT_DESKTOP: 0,
  LOGIN_LABEL: '',
  LOGIN_BUTTON_LABEL: '',
  PLATFORM_LOGIN_LABEL: '',
  LOGOUT_LABEL: '',
  SHOW_LOGIN: false,
  SHOW_PLATFORM_LOGIN: false,
  SHOW_SEARCH: false,
  SHOW_SHARE: false,
  SHOW_FOLLOW: false,
  SHOW_CONTACT_US: false,
  SHOW_LINEAR_NAVIGATION: false,
  INCLUDE_PROFILE: false
};
export var EnvContext = React.createContext(defaultEnvConfig);
export var EnvProvider = EnvContext.Provider;